const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/social-marketing`;

export const BRANDS = {
  affidya: { id: "affidya", label: "Affidya" },
  casadiriposoperte: { id: "casadiriposoperte", label: "Casadiriposoperte" },
  rco: { id: "rco", label: "R&CO Group" },
};

export const STATUS_META = {
  in_revisione: { label: "In revisione", tone: "warning" },
  approvato: { label: "Approvato", tone: "info" },
  programmato: { label: "Inviato a Postiz", tone: "accent" },
  pubblicato: { label: "Pubblicato", tone: "success" },
  rifiutato: { label: "Rifiutato", tone: "neutral" },
  errore: { label: "Errore", tone: "danger" },
};

export const LOCKED_STATUSES = ["programmato", "pubblicato"];

export const SOCIAL_PLATFORMS = [
  { id: "instagram", label: "Instagram" },
  { id: "facebook", label: "Facebook" },
  { id: "linkedin", label: "LinkedIn" },
  { id: "x", label: "X" },
  { id: "tiktok", label: "TikTok" },
  { id: "youtube", label: "YouTube" },
  { id: "threads", label: "Threads" },
  { id: "pinterest", label: "Pinterest" },
];

export function platformLabel(id, fallback = "") {
  return SOCIAL_PLATFORMS.find((item) => item.id === id)?.label || fallback || id;
}

export function statusMeta(status, post) {
  const base = STATUS_META[status] || { label: status || "Sconosciuto", tone: "neutral" };
  const jobs = post?.meta_jobs || [];
  if (status === "programmato" && jobs.some((job) => job.state === "in_attesa" || job.state === "in_corso")) {
    return { label: "Programmato su Meta", tone: "accent" };
  }
  if (status === "errore" && (post?.meta_error || jobs.some((job) => job.state === "errore"))) {
    return { label: "Errore Meta", tone: "danger" };
  }
  return base;
}

function errorMessage(body, status) {
  const detail = body?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const text = detail.map((item) => item?.msg || item).filter(Boolean).join(", ");
    if (text) return text;
  }
  return body?.message || `Errore ${status}`;
}

export async function socialApi(path, options = {}) {
  const token = localStorage.getItem("super_admin_token");
  const response = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(errorMessage(body, response.status));
  return body;
}

export function toLocalInput(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromLocalInput(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) throw new Error("Orario di pubblicazione non valido");
  return date.toISOString();
}

export function formatWhen(iso, emptyLabel = "Orario da definire") {
  if (!iso) return emptyLabel;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return emptyLabel;
  return date.toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });
}

export function createdStamp(post) {
  const time = Date.parse(post?.created_at || post?.updated_at || "");
  return Number.isNaN(time) ? 0 : time;
}
